module.exports = __webpack_public_path__ + "img/car3.db315f1b.png";